import React from "react";
import Lightbox from 'lightbox-react';
import { dietImgs, skinImgs, sportsImgs } from './dietSkinSportsUtil'


export class Swipe extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { btKitName,  dietInitial, dietNumber, skinNumber, sportsType } = this.props;
    const s3Url = "https://s3-ap-northeast-1.amazonaws.com/gh-static-contents/reports"

    const dietKit = "diet_pdf";
    const skinKit = "skin_pdf";
    const sportsKit = "sports_pdf";
    const dietPrefix = "DI_";
    const skinPrefix = "SK_";
    const sportsPrefix = "SP_";
    let dietResultType = dietPrefix + dietInitial + "_" + dietNumber;
    let skinResultType = skinPrefix + skinNumber;
    let sportsResultType = sportsPrefix + sportsType;
    let dietPath = s3Url + "/" + dietKit + "/" + dietResultType + ".pdf";
    let skinPath = s3Url + "/" + skinKit + "/" + skinResultType + ".pdf";
    let sportsPath = s3Url + "/" + sportsKit + "/" + sportsResultType + ".pdf";
    let dietImages = dietPath
    let skinImages = skinPath
    let sportsImages = sportsPath
    let images = null;
    switch (btKitName) {
      case '肌タイプ':
        images = skinImages;
        break;
      case '筋肉タイプ':
        images = sportsImages;
        break;
      case '肥満タイプ':
        images = dietImages;
        break;
      default:
        // TOPに戻す
        images = "/";
        break;
    }

    return (
      <div>
        <a className="swipe_open" onClick={() => window.open(images, '_blank')}>{this.props.btKitName}<br />報告書</a>
      </div>
    );
  }
}

export default Swipe;



// WEBPACK FOOTER //
// ./src/components/Swipe.js